//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Mutation
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.DeleteInspectionMutation_ResponseAdapter
import com.wintermar.inspection.graphql.adapter.DeleteInspectionMutation_VariablesAdapter
import com.wintermar.inspection.graphql.selections.DeleteInspectionMutationSelections
import com.wintermar.inspection.graphql.type.DeleteInspectionCommandInput
import kotlin.Any
import kotlin.Boolean
import kotlin.String
import com.wintermar.inspection.graphql.type.Mutation as CompiledMutation

public data class DeleteInspectionMutation(
  public val deleteInspectionCommandInput: DeleteInspectionCommandInput,
) : Mutation<DeleteInspectionMutation.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    DeleteInspectionMutation_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = DeleteInspectionMutation_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledMutation.type
  )
  .selections(selections = DeleteInspectionMutationSelections.__root)
  .build()

  @ApolloAdaptableWith(DeleteInspectionMutation_ResponseAdapter.Data::class)
  public data class Data(
    public val deleteInspection: Any,
  ) : Mutation.Data

  public companion object {
    public const val OPERATION_ID: String =
        "a768b5b6541a87b87cc99aed7133340418340414b544573f910c46c9143ddc87"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * mutation deleteInspection($deleteInspectionCommandInput: DeleteInspectionCommandInput!) {
     *   deleteInspection(command: $deleteInspectionCommandInput)
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "mutation deleteInspection(${'$'}deleteInspectionCommandInput: DeleteInspectionCommandInput!) { deleteInspection(command: ${'$'}deleteInspectionCommandInput) }"

    public const val OPERATION_NAME: String = "deleteInspection"
  }
}
